// Gedeelde Tailwind-klassen voor Game Over (knoppen, chips, oppervlakken).

/** Neutraal, semi-transparant oppervlak waar de mesh-achtergrond doorheen schijnt. */
export const SURFACE = 'rounded-3xl bg-white/70 backdrop-blur-md dark:bg-slate-900/70';

const BTN_BASE =
  'inline-flex min-h-11 items-center justify-center gap-2 whitespace-nowrap rounded-2xl px-4 text-sm font-semibold transition-all duration-150 active:scale-95 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-600 disabled:opacity-50';

export const BTN_PRIMARY = `${BTN_BASE} bg-slate-900 text-slate-50 hover:bg-slate-800 dark:bg-slate-100 dark:text-slate-900 dark:hover:bg-white`;
export const BTN_TONAL = `${BTN_BASE} bg-black/5 text-slate-900 hover:bg-black/10 dark:bg-white/10 dark:text-slate-100 dark:hover:bg-white/15`;
export const BTN_DANGER = `${BTN_BASE} bg-rose-700 text-white hover:bg-rose-800 dark:bg-rose-500 dark:text-slate-950 dark:hover:bg-rose-400`;
export const ICON_BTN =
  'grid h-11 w-11 shrink-0 place-items-center rounded-2xl transition-all duration-150 active:scale-95 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-600';

export function chipClass(active: boolean): string {
  return `inline-flex min-h-11 items-center gap-1.5 whitespace-nowrap rounded-2xl px-3.5 text-sm font-semibold transition-all duration-150 active:scale-95 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-600 ${
    active
      ? 'bg-slate-900 text-slate-50 dark:bg-slate-100 dark:text-slate-900'
      : 'bg-black/5 text-slate-700 hover:bg-black/10 dark:bg-white/10 dark:text-slate-200 dark:hover:bg-white/15'
  }`;
}

/** Filled tonal invoerveld (AGENTS §5). */
export const INPUT =
  'w-full min-h-12 rounded-2xl border-none bg-black/5 px-4 text-base text-slate-900 outline-none focus-visible:ring-2 focus-visible:ring-sky-600 dark:border dark:border-white/10 dark:bg-slate-800/80 dark:text-slate-100';
